const STORAGE_KEY = 'paaadel-high-contrast'

function readStoredPreference() {
	try {
		return localStorage.getItem(STORAGE_KEY) === '1'
	} catch {
		return false
	}
}

function storePreference(active) {
	try {
		localStorage.setItem(STORAGE_KEY, active ? '1' : '0')
	} catch {
		// Ignore private browsing / blocked storage.
	}
}

function applyHighContrast(active) {
	document.documentElement.classList.toggle('is-high-contrast', active)
}

function updateToggleButton(btn, active) {
	btn.setAttribute('aria-pressed', active ? 'true' : 'false')
	btn.classList.toggle('is-active', active)
}

export function initHighContrast() {
	const btn = document.querySelector('[data-high-contrast-toggle]')
	if (!btn) {
		return
	}

	const initial = readStoredPreference()
	applyHighContrast(initial)
	updateToggleButton(btn, initial)

	btn.addEventListener('click', () => {
		const next = !document.documentElement.classList.contains('is-high-contrast')
		applyHighContrast(next)
		updateToggleButton(btn, next)
		storePreference(next)
	})
}
